import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import {
  clearFilter,
  searchText,
  typeSelected,
} from "../features/filter/filterSlice";

export default function Search() {
  const [searchInput, setSearchInput] = useState("");
  const [type, setType] = useState("");
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(searchText(searchInput));
    dispatch(typeSelected(type));
  }, [dispatch, searchInput, type]);
  console.log(searchInput);
  const handlClear = (e) => {
    e.preventDefault();
    dispatch(clearFilter());
    setSearchInput("");
    setType("");
  };
  return (
    <div>
      <label class="relative block">
        <span class="sr-only">Search</span>
        <span class="absolute inset-y-0 left-0 flex items-center pl-2">
          <svg viewBox="0 0 512 512" class="h-5 w-5 fill-slate-300">
            <path d="M416 208c0 45.9-14.9 88.3-40 122.7L502.6 457.4c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0L330.7 376c-34.4 25.2-76.8 40-122.7 40C93.1 416 0 322.9 0 208S93.1 0 208 0S416 93.1 416 208zM208 352c79.5 0 144-64.5 144-144s-64.5-144-144-144S64 128.5 64 208s64.5 144 144 144z" />
          </svg>
        </span>
        <input
          class="placeholder:italic placeholder:text-slate-400 block bg-white w-full border border-slate-300 rounded-md py-2 pl-9 pr-3 shadow-sm focus:outline-none focus:border-sky-500 focus:ring-sky-500 focus:ring-1 sm:text-sm"
          placeholder="Search your item..."
          type="text"
          name="search"
          onChange={(e) => setSearchInput(e.target.value)}
        />
      </label>
      <div className="form-group radio">
        <label onClick={handlClear} className="text-rose-500 cursor-pointer">
          Clear filter
        </label>
        <div className="radio_group">
          <input
            type="radio"
            value="income"
            name="transaction_type"
            onChange={(e) => setType("income")}
            checked={type === "income"}
          />
          <label>Income</label>
        </div>
        <div className="radio_group">
          <input
            type="radio"
            value="expense"
            name="transaction_type"
            placeholder="Expense"
            onChange={(e) => setType("expense")}
            checked={type === "expense"}
          />
          <label>Expense</label>
        </div>
      </div>
    </div>
  );
}
